import React, { Suspense, useMemo, useState } from 'react';
import { TaskCounts } from 'shared/utils/derive-task-counts';

import { TaskCountsContext } from './context';
import { TaskCountsResolver } from './counts-resolver';

export type TaskCountsProviderProps = {
  children: React.ReactNode;
};

// The provider itself never suspends: it seeds `counts: undefined`, renders
// children immediately, and mounts the query-consuming resolver under its own
// `<Suspense fallback={null}>` so a cold task subscription can't blank the nav.
// The resolver publishes counts upward via `setCounts` once its queries resolve.
export const TaskCountsProvider: React.FC<TaskCountsProviderProps> = ({
  children,
}) => {
  const [counts, setCounts] = useState<TaskCounts | undefined>(undefined);

  const value = useMemo(() => ({ counts }), [counts]);

  return (
    <TaskCountsContext.Provider value={value}>
      <Suspense fallback={null}>
        <TaskCountsResolver onCounts={setCounts} />
      </Suspense>
      {children}
    </TaskCountsContext.Provider>
  );
};
